import React from "react";
import ResponsiveAppBar from "../../components/navbar/responsiveAppBar";
import { Grid } from "@mui/material";

export default function Invoices() {
  return (
    <Grid>
      <ResponsiveAppBar />

      <Grid
        container
        align="center"
        justify="center"
        direction="column"
        sx={{
          // flexGrow: 1,
          py: 6,
          height: "100vh",
          overflow: "auto",
          backgroundColor: "#F3F4F6",
          //   height: "100%",
        }}
      ><Grid item>
        Coming Soon</Grid>
      </Grid>
    </Grid>
  );
}
